/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class GetLimitsResponseValue {
  'sizeLimit'?: number | null;
  'objectCountLimit'?: number | null;
  'quotaLimit'?: number | null;
  'currentQuotaUsage'?: number | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "sizeLimit",
      "baseName": "sizeLimit",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "objectCountLimit",
      "baseName": "objectCountLimit",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "quotaLimit",
      "baseName": "quotaLimit",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "currentQuotaUsage",
      "baseName": "currentQuotaUsage",
      "type": "number",
      "format": "int64"
    }  ];

  static getAttributeTypeMap() {
    return GetLimitsResponseValue.attributeTypeMap;
  }

  public constructor() {
  }
}

